var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('div',{staticClass:"areaselect"},[_vm._v("地区选择")]),_vm._v(" "),_c('van-grid',{attrs:{"column-num":1}},_vm._l((_vm.list),function(item){return _c('van-grid-item',{key:item.AreaID,attrs:{"text":item.AreaName},on:{"click":function($event){return _vm.OnDetailClick(item.AreaID)}}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c725aa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/home.vue
// module id = null
// module chunks = 